import type CardLocation from '@alltrails/amplitude/enums/CardLocation';
import type MapLocation from '@alltrails/amplitude/enums/MapLocation';
import { PageStrings } from '@alltrails/core/constants/pageStringHelpers';
import TrailheadVectorOverlay from '@alltrails/maps/components/TrailheadVectorOverlay/TrailheadVectorOverlay';

type Props = {
  detailedCardLocation?: CardLocation;
  mapLocation?: MapLocation | string;
};

const TrailheadMapComponents = ({ detailedCardLocation = 'explore tab map view', mapLocation = PageStrings.EXPLORE_ALL_PAGE }: Props) => {
  return <TrailheadVectorOverlay detailedCardLocation={detailedCardLocation} mapLocation={mapLocation} />;
};

export default TrailheadMapComponents;
